/**
 * The public demo's own namespace, `demo` (spec/24).
 *
 * A separate entry point rather than a member of `namespaces`: only the console's demo build and the kiosk's demo
 * build load it, beside their own namespaces:
 *
 *   createI18n({ language, extraResources: { en: { ...consoleResources.en, ...demoResources.en } } });
 */
import demoEn from './locales/en/demo.js';
export const demoNamespace = 'demo';
export const demoResources = {
    en: { demo: demoEn },
};
//# sourceMappingURL=demo.js.map